import React from 'react';
import styled from 'styled-components';

type Props = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

/** @deprecated  use from ui-kit */
function Button(props: Props) {
  // eslint-disable-next-line react/button-has-type
  return <button {...props} />;
}

/** @deprecated  use from ui-kit */
export default styled(Button)`
  cursor: pointer;
  padding: 6px 6px 7px;
  color: #fff;
  background: var(--primary-color);
  border: none;
  border-radius: 7px;
  font-weight: bold;
  &:hover {
    opacity: 0.9;
    color: #fff;
  }
  &:disabled {
    opacity: 0.7;
  }
`;
